import styled, { css } from 'styled-components'
import Grid from '@mui/material/Grid'
import { Paragraph, StyledTag, StyledParagraph } from 'components/shared'

export const TaskTitle = styled(Paragraph)`
  position: relative;
  word-break: break-word;
  font-size: 16px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: pre-wrap;
`

export const Wrapper = styled.div<{ active?: boolean; urgent?: boolean; adminView?: boolean; $loading?: boolean }>`
  ${({ theme, active, urgent, adminView, $loading = false }) => css`
    margin-top: 8px;
    padding: 16px 32px 16px 24px;
    border-radius: 12px;
    background: ${theme.colors.white};
    position: relative;
    transition: 0.2s;
    cursor: ${$loading ? 'default' : 'pointer'};

    ${adminView &&
    css`
      box-shadow: ${theme.boxShadows.greyLight};
    `}

    ${!$loading &&
    css`
      &:hover {
        box-shadow: ${adminView ? theme.boxShadows.greyLight : theme.boxShadows.blackLight};
        z-index: 1;
      }
    `}

    ${urgent &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 6px;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        background: ${theme.colors.red};
      }
    `}

    ${active &&
    css`
      margin-left: -16px;
      padding-left: 40px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      &:after {
        content: '';
        height: 72px;
        width: 4px;
        background: ${theme.colors.yellow};
        position: absolute;
        right: -16px;
        top: 0;
        bottom: 0;
        margin: auto 0;
      }
    `}
  `}
`

export const TaskInfoRow = styled(Grid)`
  margin-top: 8px;

  ${StyledParagraph} {
    color: ${({ theme }) => theme.colors.greySemiDark};
  }

  ${StyledTag} {
    margin: 0 6px 8px 0;
  }
`

export const UpdatedTask = styled.span`
  position: absolute;
  z-index: 1;
  right: 19px;
  top: 25px;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  background: ${({ theme }) => theme.colors.black};
`

export const AlertUrgent = styled.span`
  position: absolute;
  left: 8px;
  top: 22px;
  display: inline-flex;
  fill: ${({ theme }) => theme.colors.red};
`

export const MessageCounter = styled.div`
  ${({ theme }) => css`
    position: absolute;
    right: 16px;
    top: 22px;
    z-index: 2;
    font-weight: bold;
    font-size: 9px;
    border-radius: 50%;
    width: 14px;
    height: 14px;
    background: ${theme.colors.black};
    color: ${theme.colors.white};
    text-align: center;
  `}
`
